var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCard = function SvgCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.75H6C5.17157 6.75 4.5 7.42157 4.5 8.25L19.5 8.25C19.5 7.42157 18.8284 6.75 18 6.75ZM3 8.25V9.75V15.75C3 17.4069 4.34315 18.75 6 18.75H18C19.6569 18.75 21 17.4069 21 15.75V9.75V8.25C21 6.59315 19.6569 5.25 18 5.25H6C4.34315 5.25 3 6.59315 3 8.25ZM19.5 15.75V9.75L4.5 9.75V15.75C4.5 16.5784 5.17157 17.25 6 17.25H18C18.8284 17.25 19.5 16.5784 19.5 15.75ZM6 15.75H9V14.25H6V15.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.75H6C5.17157 6.75 4.5 7.42157 4.5 8.25L19.5 8.25C19.5 7.42157 18.8284 6.75 18 6.75ZM3 8.25V9.75V15.75C3 17.4069 4.34315 18.75 6 18.75H18C19.6569 18.75 21 17.4069 21 15.75V9.75V8.25C21 6.59315 19.6569 5.25 18 5.25H6C4.34315 5.25 3 6.59315 3 8.25ZM19.5 15.75V9.75L4.5 9.75V15.75C4.5 16.5784 5.17157 17.25 6 17.25H18C18.8284 17.25 19.5 16.5784 19.5 15.75ZM6 15.75H9V14.25H6V15.75Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "card.1b2f14c62bb62b13c2c0544552d93b40.svg";